import { AxiosInstancePlus } from '@tencent/oneid-request';
import { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';
import BaseApi from 'common/http/BaseApi';

class RolesApi extends BaseApi {
  public axiosInstance: AxiosInstancePlus = http;

  public prefixURL = '/admin/v3';
  public bffPrefix = '/admin/bff';

  /**
   * 获取所有的权限点
   * @param role_belong 角色归属，默认1即oneid超管权限点
   */
  getActionGroups<T = any>(role_belong = 1): Promise<IResponseType<T>> {
    return this.axiosInstance.get(`${this.prefixURL}/action_groups`, { params: { role_belong } });
  }

  /**
   * 获取所有的权限点
   *
   * @description 返回原始权限点与企业配置开关过滤之后的数据
   */
  getActionGroupsBff<T = any>(role_belong = 1): Promise<IResponseType<T>> {
    return this.axiosInstance.get(`${this.bffPrefix}/roles/action_groups`, {
      params: { role_belong },
    });
  }
}

export default new RolesApi();
